<template>
<div>
    <section class="contact-rssdi">
      <div class="row">
        <div class="col-lg-12">
          <h2 class="heading-tag">Contact Us</h2>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-6">
          <div class="row">
            <div class="col-sm-12">
              <img src="https://vgespl-sbpps.s3.ap-south-1.amazonaws.com/logo/contact/1.svg" /><span class="font-for-b pl-2"
                >Address</span
              >
            </div>
          </div>
          <h5 class="font-for-b">
           RSSDI Secretariat
          </h5>
          <p>
            Dr Sanjay Agarwal's Aegle Clinic for Diabetes Care
          </p>
          <p>
            A-11, Narsimha Housing Society<br />
            194, Boat Club Road Pune- 411001 ( India )
          </p>
        </div>
        <div class="col-sm-3">
          <div class="row">
            <div class="col-sm-12"><br />
              <img src="https://vgespl-sbpps.s3.ap-south-1.amazonaws.com/logo/contact/2.svg"  /><span class="font-for-b pl-2"
                >Phone</span
              >
            </div>
          </div>
          <p>020-2616003, <br />8237730003, 9823133669</p>
        </div>
        <div class="col-sm-3">
          <div class="row">
            <div class="col-sm-12"><br />
              <img src="https://vgespl-sbpps.s3.ap-south-1.amazonaws.com/logo/contact/3.svg" /><span class="font-for-b pl-2"
                >Email</span
              >
            </div>
          </div>
          <h6>rssdihq@gmail.com</h6>
        </div>
      </div>
    </section>
    <footer class="bg-light text-center color-bt-nav text-lg-start">
      <div class="text-left p-1">
        <ul class="mr-auto pt-4">
          <span class="">FOLLOW US</span>
          <li class="first-item">
             <a href="https://www.facebook.com/RSSDIofficial" target="_blank"><img
              src="https://rssdilivebucket.s3.ap-south-1.amazonaws.com/rssdi/footer1.svg"
              alt="rssdi-logo"
            /></a>
          </li>
          <li class="first-item">
           <a href="https://twitter.com/Rssdi_official" target="_blank"> <img
              src="https://rssdilivebucket.s3.ap-south-1.amazonaws.com/rssdi/footer2.svg"
              alt="rssdi-logo"
            /></a>
          </li>
          <!-- <li class="first-item">
            <img
              src="https://rssdilivebucket.s3.ap-south-1.amazonaws.com/rssdi/footer3.svg"
              alt="rssdi-logo"
            />
          </li> -->
          <li class="first-item">
            <a href="https://www.instagram.com/rssdi_official/" target="_blank"> <img
              src="https://rssdilivebucket.s3.ap-south-1.amazonaws.com/rssdi/footer4.svg"
              alt="rssdi-logo"
            /></a>
          </li>
          <span class="edupluscampus">Powered by  <a style="color: #cccccc;" href="https://edupluscampus.com/" target="_blank"> edupluscampus</a></span>
        </ul>
      </div>
    </footer>
    </div>
</template>

<script>
export default {

}
</script>

<style>

</style>